import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UserCountError.module.scss';
import { pluralLabel } from 'LearningManager/helpers/role';

interface UserCountErrorProps {
	failedCount: number;
	noun: string;
	onRetry: () => void;
}

const UserCountError: React.FC<UserCountErrorProps> = ({
	failedCount,
	noun,
	onRetry
}) => {
	const { t } = useTranslation();

	return (
		<div className={styles.root} role="alert">
			<span>
				{t(pluralLabel('learning.userCountError.message', failedCount), {
					noun,
					count: failedCount
				})}
			</span>
			<button
				type="button"
				className={styles.retry}
				onClick={onRetry}
			>
				{t('learning.userCountError.retry')}
			</button>
		</div>
	);
};

export default UserCountError;